import image1 from "../assets/accessories.jpg";
import image2 from "../assets/spares.jpg";
import image4 from "../assets/lighting.jpg";
import image3 from "../assets/tyres.jpg";
import { Text } from '../components/Text';
import { ArrowRight } from "lucide-react";


const accessoryCategories = [
  {
    title: "Popular spare parts and accessories",
    image: image1,
    large: true,
  },
  {
    title: "Body parts and Exterior Accessories",
    description:
      "Quality replacements and upgrades to keep your car looking fresh.",
    image: image2,
  },
  {
    title: "Tires and Wheels",
    description:
      "Durable, performance-tested options for all road conditions.",
    image: image3,
  },
  {
    title: "Lights, Electrical and Sensors",
    description: "Bright, safe, and built to last.",
    image: image4,
  },
];

export default function AccessoriesSection() {
  return (
    <section id="accessories" className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">

        {/* Header */}
        <div className="flex justify-between items-end mb-8">
          <div>
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-dark mb-2">
              Browse Parts and Accessories
            </h2>

            <p className="text-base md:text-lg text-muted">
              Shop Trusted Car Parts with Flexible Payments From oils,
              filters and plugs, to tyres & rims, and even sound systems.
            </p>
          </div>

          <a
            href="/accessories"
            className="hidden md:inline-flex items-center text-primary font-bold hover:opacity-80 transition-all cursor-pointer"
          >
            View All <ArrowRight className="w-5 h-5 ml-1" />
          </a>
        </div>

        {/* Categories */}
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 sm:gap-6 lg:grid-cols-4">

          {/* Large card */}
          <div
            className="relative min-h-[260px] rounded-2xl overflow-hidden bg-cover bg-center lg:min-h-[360px]"
            style={{
              backgroundImage: `url(${image1})`,
            }}
          >
            <div className="absolute inset-0 bg-gradient-to-t from-red-950/95 via-red-900/75 to-red-800/50" />

              <div className="relative z-10 flex h-full min-h-[260px] flex-col items-center justify-center px-6 text-center text-white lg:min-h-[360px]">
              <p className="text-sm tracking-[0.2em] font-medium mb-4">
                GREAT OFFERS
              </p>

              <h3 className="text-2xl md:text-3xl font-heading font-bold max-w-sm leading-tight">
                Popular spare parts and accessories
              </h3>

              <a
                href="/accessories"
                className="mt-8 text-sm font-semibold underline underline-offset-4 hover:text-white/80 transition"
              >
                View all categories 
              </a>
            </div>
          </div>

          {/* Right side */}
          <div className="contents">

            {/* Wide card */}
            <div
              className="relative min-h-[260px] rounded-2xl overflow-hidden bg-cover bg-center lg:min-h-[360px]"
              style={{
                backgroundImage: `url(${image2})`,
              }}
            >
              <div className="absolute inset-0 bg-black/60" />

              <div className="relative z-10 flex h-full min-h-[260px] flex-col items-center justify-center px-6 text-center text-white lg:min-h-[360px]">
                <h3 className="text-xl md:text-2xl font-heading font-bold">
                  Body parts and Exterior Accessories
                </h3>

                <p className="text-sm md:text-base mt-1 text-white/90">
                  Quality replacements and upgrades to keep your car looking
                  fresh.
                </p>

                <a
                  href="/accessories/body-parts"
                  className="mt-4 inline-flex bg-primary text-white px-6 py-2.5 rounded-full text-sm font-bold hover:opacity-90 transition"
                >
                  Shop Now
                </a>
              </div>
            </div>

            {/* Tires */}
            <div
              className="relative min-h-[260px] rounded-2xl overflow-hidden bg-cover bg-center lg:min-h-[360px]"
              style={{
                backgroundImage: `url(${image3})`,
              }}
            >
              <div className="absolute inset-0 bg-dark/85 mb-0" />

              <div className="relative z-10 flex h-full min-h-[260px] flex-col justify-center px-6 text-white lg:min-h-[360px]">
                <h3 className="text-xl font-heading font-bold">
                  Tires and Wheels
                </h3>

                <p className="text-sm mt-1 text-white/80 max-w-sm">
                  Durable, performance-tested options for all road conditions.
                </p>

                <a
                  href="/accessories/tires-wheels"
                  className="mt-5 inline-flex w-fit bg-primary text-white px-6 py-2.5 rounded-full text-sm font-bold hover:opacity-90 transition"
                >
                  Shop Now
                </a>
              </div>
            </div>

            {/* Lights */}
            <div
              className="relative min-h-[260px] rounded-2xl overflow-hidden bg-cover bg-center lg:min-h-[360px]"
              style={{
                backgroundImage: `url(${image4})`,
              }}
            >
              <div className="absolute inset-0 bg-black/75" />

              <div className="relative z-10 flex h-full min-h-[260px] flex-col justify-center px-6 text-white lg:min-h-[360px]">
                <h3 className="text-xl font-heading font-bold">
                  Lights, Electrical and Sensors
                </h3>

                <p className="text-sm mt-1 text-white/80 max-w-sm">
                  Bright, safe, and built to last.
                </p>

                <a
                  href="/accessories/lights-electrical"
                  className="mt-5 inline-flex w-fit bg-primary text-white px-6 py-2.5 rounded-full text-sm font-bold hover:opacity-90 transition"
                >
                  Shop Now
                </a>
              </div>
            </div>

          </div>
        </div>

        {/* Mobile View All */}
        <div className="text-center mt-8 md:hidden">
          <a
            href="/accessories"
            className="inline-flex items-center text-primary font-bold cursor-pointer"
          >
            View All <ArrowRight className="w-5 h-5 ml-1" />
          </a>
        </div>

      </div>
    </section>
  );
}